import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-4 flex items-center gap-3 relative z-10"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "text-sm font-semibold text-creation-on-background truncate" }
const _hoisted_4 = {
  key: 1,
  class: "text-sm font-semibold text-creation-on-background truncate"
}
const _hoisted_5 = { class: "creation__content" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_8 = { class: "creation__name" }
const _hoisted_9 = { class: "creation__label" }
const _hoisted_10 = { class: "creation__bubble" }
const _hoisted_11 = {
  key: 2,
  class: "p-[22px] overflow-hidden mx-auto"
}
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon w-12 h-12 stroke-[1]",
  id: "recording-button"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#mic-filled" })
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["fill"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "circle",
    d: "\n                                                        M 50, 50\n                                                        m -37, 0\n                                                        a 37,37 0 1,1 74,0\n                                                        a 37,37 0 1,1 -74,0"
  })
], -1)
const _hoisted_17 = {
  class: "text-creation-on-background",
  "font-size": "10",
  fill: "currentColor"
}
const _hoisted_18 = {
  key: 0,
  class: "absolute left-4 bottom-2 xs:bottom-4 z-20"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-[1.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-left" })
], -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReplayButtonComponent = _resolveComponent("ReplayButtonComponent")!
  const _component_BrandImageComponent = _resolveComponent("BrandImageComponent")!
  const _component_FullHeaderComponent = _resolveComponent("FullHeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["creation__container", { 'creation__container--background': _ctx.showBackgroundImage }]),
    style: _normalizeStyle({backgroundImage: _ctx.backgroundImageURL ? `url(${_ctx.backgroundImageURL})` : 'none'})
  }, [
    (_ctx.hasVideoURLs)
      ? (_openBlock(), _createBlock(_component_ReplayButtonComponent, {
          key: 0,
          onClick: _ctx.replayVideo
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showBackgroundImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_BrandImageComponent, {
            class: "w-10 h-10",
            campaign: _ctx.campaign
          }, null, 8, ["campaign"]),
          (_ctx.campaign.profile.brandLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "link",
                href: _ctx.campaign.profile.brandLink,
                target: "_blank"
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1)
              ], 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["creation__content-wrapper", { '!items-center': !_ctx.isRecordingPossible }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.isRecordingPossible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["flex-1 flex justify-center items-center text-center p-4 text-creation-on-background text-opacity-creation-high overflow-y-auto", { 'bg-creation-primary/20 backdrop-blur-2xl px-4 py-2 rounded-2xl': _ctx.showBackgroundImage }])
            }, [
              _createElementVNode("div", { innerHTML: _ctx.recordingDeniedReason }, null, 8, _hoisted_6)
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (!_ctx.showBackgroundImage)
                ? (_openBlock(), _createBlock(_component_FullHeaderComponent, {
                    key: 0,
                    campaign: _ctx.campaign
                  }, null, 8, ["campaign"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["text-center w-full text-creation-on-background", { 'bg-black/20 backdrop-blur-2xl px-4 py-2 rounded-t-2xl': _ctx.showBackgroundImage, 'mb-5': !_ctx.showBackgroundImage }])
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.campaign.profile.name || _ctx.campaign.profile.url), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.promptBubbleLabel), 1)
              ], 2),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.promptText), 1)
            ])),
        (_ctx.isRecordingPossible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "ask-record-button select-none",
                  role: "button",
                  tabindex: "0",
                  id: "prompt-start-recording-button",
                  onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitRecordingRequested && _ctx.emitRecordingRequested(...args))),
                  onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitRecordingRequested && _ctx.emitRecordingRequested(...args)))
                }, _hoisted_14, 32),
                (_openBlock(), _createElementBlock("svg", {
                  class: "ask-record-button-text",
                  viewBox: "0 0 100 100",
                  fill: _ctx.showBackgroundImage ? 'white' : ''
                }, [
                  _hoisted_16,
                  _createElementVNode("text", _hoisted_17, [
                    _createElementVNode("textPath", {
                      "xlink:href": "#circle",
                      class: _normalizeClass(["opacity-60", { 'opacity-100': _ctx.showBackgroundImage }])
                    }, _toDisplayString(_ctx.recordButtonLabel), 3)
                  ])
                ], 8, _hoisted_15))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.campaign.isNPSCampaign || _ctx.campaign.isCSATCampaign)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", {
              role: "button",
              tabindex: "0",
              class: "button button--circle button--large button--secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBack()))
            }, _hoisted_20)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_FooterComponent, {
      campaign: _ctx.campaign,
      showBackgroundImage: _ctx.showBackgroundImage
    }, null, 8, ["campaign", "showBackgroundImage"])
  ], 6))
}